// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const menuOpciones = [
    {
        label: 'Super Usuario', icon: 'pi pi-shield',
        items: [
            { label: 'Empresas', icon: 'pi pi-building', routerLink: ['/empresas'], rol: ['SUPER_USUARIO'] },
            { label: 'Plantillas', icon: 'pi pi-palette', routerLink: ['/plantillas'], rol: ['SUPER_USUARIO'] },
            { label: 'Monitoreo', icon: 'pi pi-wave-pulse', routerLink: ['/monitoreo'], rol: ['SUPER_USUARIO'] },
            { label: 'Control de empresas', icon: 'pi pi-briefcase', routerLink: ['/control-empresas'], rol: ['SUPER_USUARIO'] },
        ],
        rol: ['SUPER_USUARIO']
    },

    {
        label: 'Dashboard',
        icon: 'pi pi-chart-pie',
        routerLink: ['/dashboard'],
        rol: ['SUPER_USUARIO', 'DASHBOARD_VER']
    },
    {
        label: 'Administración', icon: 'pi pi-cog',
        items: [
            {
                label: 'Certificados digitales',
                icon: 'pi pi-verified',
                routerLink: ['/certificados'],
                rol: ['SUPER_USUARIO', 'CERTIFICADOS_VER']
            },
            {
                label: 'Empresas adjuntas',
                icon: 'pi pi-sitemap',
                routerLink: ['/empresas/adjuntas'],
                rol: ['SUPER_USUARIO', 'EMPRESAS_ADJUNTAS_VER']
            },
            {
                label: 'Ciudades',
                icon: 'pi pi-map',
                routerLink: ['/ciudades'],
                rol: ['SUPER_USUARIO', 'CIUDADES_VER']
            },
            {
                label: 'Unidades de medida',
                icon: 'pi pi-hashtag',
                routerLink: ['/unidades'],
                rol: ['SUPER_USUARIO', 'UNIDADES_VER']
            },
            {
                label: 'Finanzas',
                icon: 'pi pi-wallet',
                items: [
                    {
                        label: 'Métodos de pago',
                        icon: 'pi pi-credit-card',
                        routerLink: ['/formas-pago'],
                        rol: ['SUPER_USUARIO', 'FORMAS_PAGO_VER']
                    },
                    {
                        label: 'Monedas',
                        icon: 'pi pi-dollar',
                        routerLink: ['/monedas'],
                        rol: ['SUPER_USUARIO', 'MONEDAS_VER']
                    },
                    {
                        label: 'Bancos',
                        icon: 'pi pi-building-columns',
                        routerLink: ['/bancos'],
                        rol: ['SUPER_USUARIO', 'BANCOS_VER']
                    },
                    {
                        label: 'Cuentas bancarias',
                        icon: 'pi pi-briefcase',
                        routerLink: ['/cuentas-bancarias'],
                        rol: ['SUPER_USUARIO', 'CUENTAS_BANCARIAS_VER']
                    },
                ],
                rol: ['SUPER_USUARIO', 'CUENTAS_BANCARIAS_VER', 'BANCOS_VER', 'MONEDAS_VER', 'FORMAS_PAGO_VER']
            },
            {
                label: 'Horarios',
                icon: 'pi pi-clock',
                routerLink: ['/horarios'],
                rol: ['SUPER_USUARIO', 'HORARIOS_VER']
            },
            {
                label: 'Puntos de venta',
                icon: 'pi pi-map-marker',
                routerLink: ['/puntos-venta'],
                rol: ['SUPER_USUARIO', 'PUNTO_VENTA_VER']
            },
            {
                label: 'Estaciones de venta',
                icon: 'pi pi-desktop',
                routerLink: ['/estaciones-venta'],
                rol: ['SUPER_USUARIO', 'SALE_STATION_VER']
            },
            {
                label: 'Series documentos',
                icon: 'pi pi-sort-numeric-down',
                routerLink: ['/series'],
                rol: ['SUPER_USUARIO', 'SERIES_DOCUMENTOS_VER']
            },
            {
                label: 'Productos', icon: 'pi pi-th-large',
                items: [
                    {
                        label: 'Articulos',
                        icon: 'pi pi-barcode',
                        routerLink: ['/productos'],
                        rol: ['SUPER_USUARIO', 'PRODUCTOS_VER']
                    },
                    {
                        label: 'Preparaciones',
                        icon: 'pi pi-list-check',
                        routerLink: ['/preparaciones'],
                        rol: ['SUPER_USUARIO', 'PREPARACIONES_VER']
                    },
                    {
                        label: 'Grupos',
                        icon: 'pi pi-objects-column',
                        routerLink: ['/grupos'],
                        rol: ['SUPER_USUARIO', 'GRUPOS_VER']
                    },
                    {
                        label: 'Categorías',
                        icon: 'pi pi-folder-open',
                        routerLink: ['/categorias/0'],
                        rol: ['SUPER_USUARIO', 'CATEGORIAS_VER']
                    },
                    {
                        label: 'Marcas',
                        icon: 'pi pi-tag',
                        routerLink: ['/marcas'],
                        rol: ['SUPER_USUARIO', 'MARCAS_VER']
                    }
                ],
                rol: ['SUPER_USUARIO', 'PRODUCTOS_VER', 'CATEGORIAS_VER', 'MARCAS_VER']
            },
            {
                label: 'Clientes',
                icon: 'pi pi-address-book',
                routerLink: ['/clientes'],
                rol: ['SUPER_USUARIO', 'CLIENTES_VER']
            },
            {
                label: 'Empleados',
                icon: 'pi pi-id-card',
                items: [
                    {
                        label: 'Ver Empleados',
                        icon: 'pi pi-list',
                        routerLink: ['/empleados'],
                        rol: ['SUPER_USUARIO', 'EMPLEADOS_VER']
                    },
                    {
                        label: 'Asistencia',
                        icon: 'pi pi-calendar-clock',
                        routerLink: ['/empleados/asistencia'],
                        rol: ['SUPER_USUARIO', 'EMPLEADOS_ASISTENCIA_VER']
                    }
                ],
                rol: ['SUPER_USUARIO', 'EMPLEADOS_VER', 'EMPLEADOS_ASISTENCIA_VER']
            },
            {
                label: 'Proveedores',
                icon: 'pi pi-truck',
                routerLink: ['/proveedores'],
                rol: ['SUPER_USUARIO', 'PROVEEDORES_VER']
            },
            {
                label: 'Canal de venta',
                icon: 'pi pi-share-alt',
                routerLink: ['/canal-ventas'],
                rol: ['SUPER_USUARIO', 'VENTAS_CREAR']
            },
            {
                label: 'Impresoras',
                icon: 'pi pi-print',
                routerLink: ['/impresoras'],
                rol: ['SUPER_USUARIO', 'IMPRESORA_VER']
            },
            {
                label: 'Usuarios',
                icon: 'pi pi-user',
                items: [
                    {
                        label: 'Ver usuarios',
                        icon: 'pi pi-list',
                        routerLink: ['/usuarios'],
                        rol: ['SUPER_USUARIO', 'USUARIOS_VER']
                    },
                    {
                        label: 'Perfiles de usuario',
                        icon: 'pi pi-id-card',
                        routerLink: ['/perfiles'],
                        rol: ['SUPER_USUARIO', 'PERFILES_VER']
                    },
                    {
                        label: 'Roles',
                        icon: 'pi pi-key',
                        routerLink: ['/roles'],
                        rol: ['SUPER_USUARIO', 'USUARIOS_VER']
                    }
                ],
                rol: ['SUPER_USUARIO', 'USUARIOS_VER', 'PERFILES_VER']
            },
            {
                label: 'Notificaciones',
                icon: 'pi pi-bell',
                routerLink: ['/notificaciones'],
                rol: ['SUPER_USUARIO', 'USUARIOS_VER']
            }
        ],
        rol: ['SUPER_USUARIO', 'UNIDADES_VER', 'BANCOS_VER', 'CUENTAS_BANCARIAS_VER',
            'PUNTO_VENTA_VER', 'HORARIOS_VER', 'SERIES_DOCUMENTOS_VER', 'PRODUCTOS_VER', 'CATEGORIAS_VER',
            'MARCAS_VER', 'CLIENTES_VER', 'PROVEEDORES_VER', 'USUARIOS_VER', 'PERFILES_VER', 'EMPLEADOS_VER', 'EMPLEADOS_ASISTENCIA_VER', 'CATALOGO_VER']
    },
    {
        label: 'Compras', icon: 'pi pi-cart-arrow-down',
        items: [
            {
                label: 'Ver compras',
                icon: 'pi pi-list',
                routerLink: ['/compras'],
                rol: ['SUPER_USUARIO', 'COMPRAS_VER']
            },
            {
                label: 'Nueva compra',
                icon: 'pi pi-plus',
                routerLink: ['/compras/nueva-compra'],
                rol: ['SUPER_USUARIO', 'COMPRAS_CREAR']
            },
            {
                label: 'Compras SUNAT',
                icon: 'pi pi-cloud-download',
                routerLink: ['/compras/sunat'],
                rol: ['SUPER_USUARIO', 'COMPRAS_VER']
            },
            {
                label: 'Ordenes de compra', icon: 'pi pi-clipboard',
                items: [
                    {
                        label: 'Ver órdenes',
                        icon: 'pi pi-list',
                        routerLink: ['/compras/ver-ordenes'],
                        rol: ['SUPER_USUARIO', 'ORDEN_COMPRA_VER']
                    },
                    {
                        label: 'Nueva orden',
                        icon: 'pi pi-plus',
                        routerLink: ['/compras/nueva-orden'],
                        rol: ['SUPER_USUARIO', 'ORDEN_COMPRA_CREAR']
                    }
                ],
                rol: ['SUPER_USUARIO', 'ORDEN_COMPRA_VER', 'ORDEN_COMPRA_CREAR']
            },
        ],
        rol: ['SUPER_USUARIO', 'COMPRAS_VER', 'COMPRAS_CREAR', 'ORDEN_COMPRA_VER', 'ORDEN_COMPRA_CREAR']
    },
    {
        label: 'Ventas', icon: 'pi pi-shopping-cart',
        items: [
            {
                label: 'Ver comprobantes',
                icon: 'pi pi-receipt',
                routerLink: ['/ventas/ver-comprobantes'],
                rol: ['SUPER_USUARIO', 'VENTAS_VER']
            },
            {
                label: 'Ver contingencias',
                icon: 'pi pi-exclamation-triangle',
                routerLink: ['/ventas/ver-contingencias'],
                rol: ['SUPER_USUARIO', 'VENTAS_VER']
            },
            {
                label: 'Nueva venta',
                icon: 'pi pi-cart-plus',
                routerLink: ['/ventas/nueva-venta'],
                rol: ['SUPER_USUARIO', 'VENTAS_CREAR']
            },
            {
                label: 'Venta POS',
                ventaAlternativa: true,
                icon: 'pi pi-bolt',
                routerLink: ['/ventas/pos'],
                rol: ['SUPER_USUARIO', 'VENTAS_CREAR']
            },
            {
                label: 'Nota de Crédito',
                icon: 'pi pi-minus-circle',
                routerLink: ['/ventas/emitir-nota-credito'],
                rol: ['SUPER_USUARIO', 'VENTAS_CREAR']
            },
            {
                label: 'Nota de Débito',
                icon: 'pi pi-plus-circle',
                routerLink: ['/ventas/emitir-nota-debito'],
                rol: ['SUPER_USUARIO', 'VENTAS_CREAR']
            },
            {
                label: 'Guías de remisión', icon: 'pi pi-truck',
                items: [
                    {
                        label: 'Ver Guías',
                        icon: 'pi pi-list',
                        routerLink: ['/guia-remision/ver-guias'],
                        rol: ['SUPER_USUARIO', 'GUIA_REMISION_CREAR']
                    },
                    {
                        label: 'Nueva Guía',
                        icon: 'pi pi-plus',
                        routerLink: ['/guia-remision/emitir-guia'],
                        rol: ['SUPER_USUARIO', 'GUIA_REMISION_CREAR']
                    }
                ],
                rol: ['SUPER_USUARIO', 'GUIA_REMISION_CREAR']
            },
            {
                label: 'Cotizaciones', icon: 'pi pi-file-edit',
                items: [
                    {
                        label: 'Ver Cotizaciones',
                        icon: 'pi pi-list',
                        routerLink: ['/ventas/ver-cotizaciones'],
                        rol: ['SUPER_USUARIO', 'COTIZACION_VER']
                    },
                    {
                        label: 'Nueva Cotización',
                        icon: 'pi pi-plus',
                        routerLink: ['/ventas/nueva-cotizacion'],
                        rol: ['SUPER_USUARIO', 'COTIZACION_VER']
                    }
                ],
                rol: ['SUPER_USUARIO', 'COTIZACION_VER']
            },
            {
                label: 'Pedidos', icon: 'pi pi-inbox',
                items: [
                    {
                        label: 'Ver Pedidos',
                        icon: 'pi pi-list',
                        routerLink: ['/ventas/ver-pedidos'],
                        rol: ['SUPER_USUARIO', 'COTIZACION_VER']
                    },
                    {
                        label: 'Nuevo Pedido',
                        icon: 'pi pi-plus',
                        routerLink: ['/ventas/nuevo-pedido'],
                        rol: ['SUPER_USUARIO', 'COTIZACION_VER']
                    }
                ],
                rol: ['SUPER_USUARIO', 'COTIZACION_VER']
            },
            {
                label: 'Despacho',
                icon: 'pi pi-box',
                routerLink: ['/ventas/despacho'],
                rol: ['SUPER_USUARIO', 'VENTAS_DESPACHO_VER']
            },
            {
                label: 'Descargas masivas',
                icon: 'pi pi-download',
                routerLink: ['/ventas/descargas-masivas'],
                rol: ['SUPER_USUARIO', 'VENTAS_VER']
            },
        ],
        rol: ['SUPER_USUARIO', 'COTIZACION_VER', 'GUIA_REMISION_CREAR', 'VENTAS_VER', 'VENTAS_CREAR']
    },
    {
        // Cartera de clientes (CRM): aquí se sumarán Inicio, Comunicaciones y Automatizaciones.
        label: 'Cartera de clientes', icon: 'pi pi-heart',
        items: [
            {
                label: 'Ficha 360°',
                icon: 'pi pi-id-card',
                routerLink: ['/cartera-clientes'],
                rol: ['SUPER_USUARIO', 'CLIENTES_VER']
            },
            {
                label: 'Automatizaciones',
                icon: 'pi pi-bolt',
                routerLink: ['/cartera-clientes/automatizaciones'],
                rol: ['SUPER_USUARIO', 'CLIENTES_VER']
            },
            {
                label: 'Registro de mensajes',
                icon: 'pi pi-send',
                routerLink: ['/cartera-clientes/mensajes'],
                rol: ['SUPER_USUARIO', 'CLIENTES_VER']
            }
        ],
        rol: ['SUPER_USUARIO', 'CLIENTES_VER']
    },

    {
        label: 'Tienda Online', icon: 'pi pi-globe',
        showCountNotifications: true,
        countNotificationTypes: ['PEDIDO_CATALOGO', 'PEDIDO_MENU'],
        items: [
            {
                label: 'Catálogo en línea',
                icon: 'pi pi-shopping-bag',
                routerLink: ['/gestion-catalogo'],
                rol: ['SUPER_USUARIO', 'CATALOGO_VER']
            },
            {
                label: 'Menú Cliente',
                icon: 'pi pi-book',
                routerLink: ['/configuracion-menu-cliente'],
                rol: ['SUPER_USUARIO', 'MENU_CLIENTE_VER']
            },
            {
                label: 'Pedidos online',
                showCountNotifications: true,
                countNotificationTypes: ['PEDIDO_CATALOGO', 'PEDIDO_MENU'],
                icon: 'pi pi-shopping-cart',
                routerLink: ['/ventas/pedidos-tienda-online'],
                rol: ['SUPER_USUARIO', 'CATALOGO_VER', 'MENU_CLIENTE_VER']
            }
        ],
        rol: ['SUPER_USUARIO', 'CATALOGO_VER', 'MENU_CLIENTE_VER']
    },

    {
        label: 'Restaurante', icon: 'pi pi-shop',
        items: [
            {
                label: 'Comandero',
                icon: 'pi pi-clipboard',
                routerLink: ['/restaurante'],
                rol: ['SUPER_USUARIO', 'RESTAURANTE_COMANDAS_VER']
            },
            {
                label: 'Pedidos',
                icon: 'pi pi-list',
                routerLink: ['/restaurante/pedidos'],
                rol: ['SUPER_USUARIO', 'RESTAURANTE_PEDIDOS_VER']
            },
            {
                label: 'Cocina',
                icon: 'pi pi-stopwatch',
                routerLink: ['/restaurante/cocina'],
                rol: ['SUPER_USUARIO', 'RESTAURANTE_COCINA_VER']
            },
            {
                label: 'Por servir',
                icon: 'pi pi-bell',
                routerLink: ['/restaurante/por-servir'],
                rol: ['SUPER_USUARIO', 'RESTAURANTE_COMANDAS_VER']
            },
            {
                label: 'Reparto',
                icon: 'pi pi-truck',
                routerLink: ['/restaurante/reparto'],
                rol: ['SUPER_USUARIO', 'REPARTO_VER']
            },
            {
                label: 'Carta QR',
                icon: 'pi pi-qrcode',
                routerLink: ['/restaurante/carta-qr'],
                rol: ['SUPER_USUARIO', 'RESTAURANTE_MESAS_VER']
            },
            {
                label: 'Mantenimientos',
                icon: 'pi pi-wrench',
                items: [
                    {
                        label: 'Salones',
                        icon: 'pi pi-home',
                        routerLink: ['/restaurante/salones'],
                        rol: ['SUPER_USUARIO', 'RESTAURANTE_SALONES_VER']
                    },
                    {
                        label: 'Mesas',
                        icon: 'pi pi-table',
                        routerLink: ['/restaurante/mesas'],
                        rol: ['SUPER_USUARIO', 'RESTAURANTE_MESAS_VER']
                    },
                    {
                        label: 'Area de producción',
                        icon: 'pi pi-warehouse',
                        routerLink: ['/restaurante/zonas-produccion'],
                        rol: ['SUPER_USUARIO', 'RESTAURANTE_ZONAS_VER']
                    }
                ],
                rol: ['SUPER_USUARIO', 'RESTAURANTE_MESAS_VER', 'RESTAURANTE_SALONES_VER', 'RESTAURANTE_ZONAS_VER']
            },
            {
                label: 'Reporte propinas',
                icon: 'pi pi-wallet',
                routerLink: ['/restaurante/reporte-propinas'],
                rol: ['SUPER_USUARIO', 'RESTAURANTE_PROPINAS_REPORTE']
            }
        ],
        rol: ['SUPER_USUARIO', 'RESTAURANTE_COMANDAS_VER', 'RESTAURANTE_MESAS_VER', 'RESTAURANTE_SALONES_VER', 'REPARTO_VER', 'RESTAURANTE_PROPINAS_REPORTE']
    },

    {
        label: 'Clínica', icon: 'pi pi-heart-fill',
        items: [
            {
                label: 'Agenda',
                icon: 'pi pi-calendar',
                routerLink: ['/clinica/agenda'],
                rol: ['SUPER_USUARIO', 'CLINICA_CITAS_VER']
            },
            {
                label: 'Pacientes',
                icon: 'pi pi-users',
                routerLink: ['/clinica/pacientes'],
                rol: ['SUPER_USUARIO', 'CLINICA_PACIENTES_VER']
            },
            {
                label: 'Médicos',
                icon: 'pi pi-id-card',
                routerLink: ['/clinica/medicos'],
                rol: ['SUPER_USUARIO', 'CLINICA_MEDICOS_VER']
            },
            {
                label: 'Historia Clínica',
                icon: 'pi pi-folder',
                routerLink: ['/clinica/historias-clinicas'],
                rol: ['SUPER_USUARIO', 'CLINICA_HISTORIA_VER']
            },
            {
                label: 'Planes de Tratamiento',
                icon: 'pi pi-list-check',
                routerLink: ['/clinica/planes-tratamiento'],
                rol: ['SUPER_USUARIO', 'CLINICA_PLANES_VER']
            },
            {
                label: 'Reportes',
                icon: 'pi pi-chart-bar',
                routerLink: ['/clinica/reportes'],
                rol: ['SUPER_USUARIO', 'CLINICA_REPORTES_VER']
            }
        ],
        rol: ['SUPER_USUARIO', 'CLINICA_CITAS_VER', 'CLINICA_PACIENTES_VER', 'CLINICA_MEDICOS_VER', 'CLINICA_HISTORIA_VER', 'CLINICA_PLANES_VER', 'CLINICA_REPORTES_VER']
    },

    {
        label: 'Estacion de Servicios',
        icon: 'pi pi-gauge',
        items: [
            {
                label: 'Gestionar islas',
                icon: 'pi pi-sitemap',
                routerLink: ['/contometro'],
                rol: ['SUPER_USUARIO', 'CONTOMETRO_VER'],
            },
            {
                label: 'Gestionar contómetros',
                icon: 'pi pi-sliders-h',
                routerLink: ['/contometro/gestionar'],
                rol: ['SUPER_USUARIO', 'CONTOMETRO_VER'],
                requiresEsGasolinera: true
            },
            {
                label: 'Reporte de contometros',
                icon: 'pi pi-chart-bar',
                routerLink: ['/contometro/reporte'],
                rol: ['SUPER_USUARIO', 'CONTOMETRO_REPORTE'],
            }
        ],
        rol: ['SUPER_USUARIO', 'CONTOMETRO_VER', 'CONTOMETRO_REPORTE'],
    },
    {
        label: 'Operaciones',
        icon: 'pi pi-briefcase',
        items: [
            {
                label: 'Caja',
                icon: 'pi pi-money-bill',
                routerLink: ['/caja'],
                rol: ['SUPER_USUARIO', 'CAJA_VER']
            },
            {
                label: 'Reporte de cajas',
                icon: 'pi pi-chart-bar',
                routerLink: ['/caja/reporte'],
                rol: ['SUPER_USUARIO', 'CAJA_VER_HISTORIAL']
            },
            {
                label: 'Membresias',
                icon: 'pi pi-crown',
                routerLink: ['/membresias'],
                rol: ['SUPER_USUARIO', 'MEMBRESIAS_VER']
            },
            {
                label: 'Cuentas por cobrar',
                icon: 'pi pi-arrow-down-left',
                routerLink: ['/cuentas-por-cobrar'],
                rol: ['SUPER_USUARIO', 'CUENTAS_POR_COBRAR_VER']
            },
            {
                label: 'Cuentas por Pagar',
                icon: 'pi pi-arrow-up-right',
                routerLink: ['/cuentas-por-cobrar/pagar'],
                rol: ['SUPER_USUARIO', 'CUENTAS_POR_PAGAR_VER']
            },
            {
                label: 'Facturación Electrónica', icon: 'pi pi-cloud-upload',
                items: [
                    {
                        label: 'Resumen diario',
                        icon: 'pi pi-calendar',
                        routerLink: ['/facturacion-electronica/resumen-diario/ver-resumenes-diarios'],
                        rol: ['SUPER_USUARIO', 'RESUMEN_DIARIO_VER']
                    },
                    {
                        label: 'Comunicación de baja',
                        icon: 'pi pi-ban',
                        routerLink: ['/facturacion-electronica/comunicacion-baja/ver-comunicaciones-baja'],
                        rol: ['SUPER_USUARIO', 'COMUNICACION_BAJA_VER']
                    }
                ],
                rol: ['SUPER_USUARIO', 'RESUMEN_DIARIO_VER', 'COMUNICACION_BAJA_VER']
            },
            {
                label: 'Inventario',
                icon: 'pi pi-database',
                rol: ['SUPER_USUARIO', 'INVENTARIO_VER', 'INVENTARIO_AJUSTAR', 'INVENTARIO_TRASLADAR', 'INVENTARIO_ORDENES_PRODUCCION'],
                items: [
                    {
                        label: 'Inventario de productos',
                        icon: 'pi pi-list',
                        routerLink: ['/inventario'],
                        rol: ['SUPER_USUARIO', 'INVENTARIO_VER']
                    },
                    {
                        label: 'Envases pendientes', icon: 'pi pi-sync', routerLink: ['/inventario/envases-prestados'],
                        rol: ['SUPER_USUARIO', 'INVENTARIO_VER'], requiresReturnableContainers: true
                    },
                    {
                        label: 'Lotes y series',
                        icon: 'pi pi-tags',
                        routerLink: ['/inventario/lotes'],
                        rol: ['SUPER_USUARIO', 'INVENTARIO_VER']
                    },
                    {
                        label: 'Ajustes de inventario',
                        icon: 'pi pi-sliders-v',
                        routerLink: ['/inventario-ajustes'],
                        rol: ['SUPER_USUARIO', 'INVENTARIO_AJUSTAR']
                    },
                    {
                        label: 'Traslados de inventario',
                        icon: 'pi pi-arrow-right-arrow-left',
                        routerLink: ['/inventario-traslados'],
                        rol: ['SUPER_USUARIO', 'INVENTARIO_TRASLADAR']
                    },
                    {
                        label: 'Ordenes de producción',
                        icon: 'pi pi-hammer',
                        routerLink: ['/inventario-ordenes-produccion'],
                        rol: ['SUPER_USUARIO', 'INVENTARIO_ORDENES_PRODUCCION']
                    }
                ],
            },
        ],
        rol: ['SUPER_USUARIO', 'CAJA_VER', 'CAJA_VER_HISTORIAL', 'CUENTAS_POR_COBRAR_VER', 'RESUMEN_DIARIO_VER', 'COMUNICACION_BAJA_VER', 'INVENTARIO_VER', 'INVENTARIO_AJUSTAR', 'INVENTARIO_TRASLADAR', 'INVENTARIO_ORDENES_PRODUCCION']
    },
    {
        label: 'Reportes',
        icon: 'pi pi-chart-bar',
        items: [
            {
                label: 'Reporte de ventas',
                icon: 'pi pi-chart-line',
                routerLink: ['/reportes/reporte-ventas'],
                rol: ['SUPER_USUARIO', 'REPORTE_VENTAS']
            },
            {
                label: 'Reporte de movimientos',
                icon: 'pi pi-history',
                routerLink: ['/reportes/reporte-movimientos'],
                rol: ['SUPER_USUARIO', 'REPORTE_MOVIMIENTOS']
            },
            {
                label: 'Reporte ABC',
                icon: 'pi pi-sort-amount-down',
                routerLink: ['/reportes/reporte-abc'],
                rol: ['SUPER_USUARIO', 'REPORTE_ABC']
            },
            {
                label: 'Reporte de margenes',
                icon: 'pi pi-percentage',
                routerLink: ['/reportes/reporte-margenes'],
                rol: ['SUPER_USUARIO', 'REPORTE_MARGENES']
            },
            {
                label: 'Reporte de rotacion de inventario',
                icon: 'pi pi-refresh',
                routerLink: ['/reportes/reporte-rotacion'],
                rol: ['SUPER_USUARIO', 'REPORTE_ROTACION']
            },
            {
                label: 'Comparativo de ventas',
                icon: 'pi pi-chart-scatter',
                routerLink: ['/reportes/reporte-comparativo-ventas'],
                rol: ['SUPER_USUARIO', 'REPORTE_COMPARATIVO_VENTAS']
            },
            {
                label: 'Reporte de clientes',
                icon: 'pi pi-address-book',
                routerLink: ['/reportes/reporte-clientes'],
                rol: ['SUPER_USUARIO', 'REPORTE_CLIENTES']
            },
            {
                label: 'Reportes Restaurante', icon: 'pi pi-shop',
                items: [
                    {
                        label: 'Rendimiento de mozos',
                        icon: 'pi pi-star',
                        routerLink: ['/reportes/reporte-mozos-performance'],
                        rol: ['SUPER_USUARIO', 'REPORTE_MOZOS_PERFORMANCE']
                    },
                    {
                        label: 'Platos por horario',
                        icon: 'pi pi-clock',
                        routerLink: ['/reportes/reporte-platos-horario'],
                        rol: ['SUPER_USUARIO', 'REPORTE_PLATOS_HORARIO']
                    },
                    {
                        label: 'Comandas anuladas',
                        icon: 'pi pi-times-circle',
                        routerLink: ['/reportes/reporte-comandas-anuladas'],
                        rol: ['SUPER_USUARIO', 'REPORTE_COMANDAS_ANULADAS']
                    },
                    {
                        label: 'Analisis Food Cost',
                        icon: 'pi pi-chart-pie',
                        routerLink: ['/reportes/reporte-food-cost'],
                        rol: ['SUPER_USUARIO', 'REPORTE_FOOD_COST']
                    }
                ],
                rol: ['SUPER_USUARIO', 'COTIZACION_VER']
            },
        ],
        rol: ['SUPER_USUARIO', 'REPORTE_VENTAS']
    },
    {
        label: 'Fidelización',
        icon: 'pi pi-star',
        items: [
            {
                label: 'Tarjetas',
                icon: 'pi pi-id-card',
                routerLink: ['/loyalti/config'],
                rol: ['SUPER_USUARIO', 'LOYALTI_CONFIG_VER']
            },
            {
                label: 'Clientes Fidelizados',
                icon: 'pi pi-heart',
                routerLink: ['/loyalti/customers'],
                rol: ['SUPER_USUARIO', 'LOYALTI_CUSTOMERS_VER']
            },
            {
                label: 'Definición de Cupones',
                icon: 'pi pi-ticket',
                routerLink: ['/loyalti/coupon-defs'],
                rol: ['SUPER_USUARIO', 'LOYALTI_COUPON_DEFS_VER']
            },
            {
                label: 'Cupones Emitidos',
                icon: 'pi pi-tags',
                routerLink: ['/loyalti/coupons'],
                rol: ['SUPER_USUARIO', 'LOYALTI_COUPONS_VER']
            }
        ],
        rol: ['SUPER_USUARIO', 'LOYALTI_CONFIG_VER', 'LOYALTI_CUSTOMERS_VER', 'LOYALTI_COUPON_DEFS_VER', 'LOYALTI_COUPONS_VER']
    },
    {
        label: 'Herramientas Cont.',
        icon: 'pi pi-calculator',
        routerLink: ['/herramientas-contadores'],
        rol: ['SUPER_USUARIO', 'HERRAMIENTAS_CONTADORES']
    }
];

export const menuShortcuts = [
    // --- Ventas / operación diaria ---
    {
        label: 'Nueva venta',
        grupo: 'Ventas',
        value: {
            nombre: 'Nueva venta',
            icono: 'pi pi-cart-plus',
            ruta: '/ventas/nueva-venta',
            rol: ['SUPER_USUARIO', 'VENTAS_CREAR']
        },
    },
    {
        label: 'Venta alternativa',
        grupo: 'Ventas',
        value: {
            nombre: 'Venta alternativa',
            icono: 'pi pi-bolt',
            ruta: '/ventas/pos',
            rol: ['SUPER_USUARIO', 'VENTAS_CREAR']
        },
    },
    {
        label: 'Ver comprobantes',
        grupo: 'Ventas',
        value: {
            nombre: 'Ver comprobantes',
            icono: 'pi pi-receipt',
            ruta: '/ventas/ver-comprobantes',
            rol: ['SUPER_USUARIO', 'VENTAS_VER']
        }
    },
    {
        label: 'Nota de crédito',
        grupo: 'Ventas',
        value: {
            nombre: 'Nota de crédito',
            icono: 'pi pi-minus-circle',
            ruta: '/ventas/emitir-nota-credito',
            rol: ['SUPER_USUARIO', 'VENTAS_CREAR']
        }
    },
    {
        label: 'Nueva Cotización',
        grupo: 'Ventas',
        value: {
            nombre: 'Nueva Cotización',
            icono: 'pi pi-file-edit',
            ruta: '/ventas/nueva-cotizacion',
            rol: ['SUPER_USUARIO', 'COTIZACION_VER']
        },
    },
    {
        label: 'Nuevo pedido',
        grupo: 'Ventas',
        value: {
            nombre: 'Nuevo pedido',
            icono: 'pi pi-inbox',
            ruta: '/ventas/nuevo-pedido',
            rol: ['SUPER_USUARIO', 'COTIZACION_VER']
        }
    },
    {
        label: 'Nueva guía de remisión',
        grupo: 'Ventas',
        value: {
            nombre: 'Nueva guía de remisión',
            icono: 'pi pi-truck',
            ruta: '/guia-remision/emitir-guia',
            rol: ['SUPER_USUARIO', 'GUIA_REMISION_CREAR']
        }
    },
    {
        label: 'Pedidos online',
        grupo: 'Ventas',
        value: {
            nombre: 'Pedidos online',
            icono: 'pi pi-shopping-cart',
            ruta: '/ventas/pedidos-tienda-online',
            rol: ['SUPER_USUARIO', 'CATALOGO_VER']
        }
    },
    // --- Operación / finanzas ---
    {
        label: 'Caja',
        grupo: 'Operación y finanzas',
        value: {
            nombre: 'Caja',
            icono: 'pi pi-money-bill',
            ruta: '/caja',
            rol: ['SUPER_USUARIO', 'CAJA_VER']
        },
    },
    {
        label: 'Cuentas por cobrar',
        grupo: 'Operación y finanzas',
        value: {
            nombre: 'Cuentas por cobrar',
            icono: 'pi pi-arrow-down-left',
            ruta: '/cuentas-por-cobrar',
            rol: ['SUPER_USUARIO', 'CUENTAS_POR_COBRAR_VER']
        }
    },
    {
        label: 'Dashboard',
        grupo: 'Operación y finanzas',
        value: {
            nombre: 'Dashboard',
            icono: 'pi pi-chart-pie',
            ruta: '/dashboard',
            rol: ['SUPER_USUARIO', 'DASHBOARD_VER']
        }
    },
    {
        label: 'Reporte de ventas',
        grupo: 'Operación y finanzas',
        value: {
            nombre: 'Reporte de ventas',
            icono: 'pi pi-chart-line',
            ruta: '/reportes/reporte-ventas',
            rol: ['SUPER_USUARIO', 'REPORTE_VENTAS']
        }
    },
    {
        label: 'Inventario',
        grupo: 'Operación y finanzas',
        value: {
            nombre: 'Inventario',
            icono: 'pi pi-database',
            ruta: '/inventario',
            rol: ['SUPER_USUARIO', 'INVENTARIO_VER']
        }
    },
    // --- Catálogo / administración ---
    {
        label: 'Articulos',
        grupo: 'Catálogo y administración',
        value: {
            nombre: 'Articulos',
            icono: 'pi pi-barcode',
            ruta: '/productos',
            rol: ['SUPER_USUARIO', 'PRODUCTOS_VER']
        }
    },
    {
        label: 'Clientes',
        grupo: 'Catálogo y administración',
        value: {
            nombre: 'Clientes',
            icono: 'pi pi-address-book',
            ruta: '/clientes',
            rol: ['SUPER_USUARIO', 'CLIENTES_VER']
        }
    },
    {
        label: 'Empleados',
        grupo: 'Catálogo y administración',
        value: {
            nombre: 'Empleados',
            icono: 'pi pi-id-card',
            ruta: '/empleados',
            rol: ['SUPER_USUARIO', 'EMPLEADOS_VER']
        },
    },
    {
        label: 'Usuarios',
        grupo: 'Catálogo y administración',
        value: {
            nombre: 'Usuarios',
            icono: 'pi pi-user',
            ruta: '/usuarios',
            rol: ['SUPER_USUARIO', 'USUARIOS_VER']
        }
    },
    // --- Compras ---
    {
        label: 'Ver compras',
        grupo: 'Compras',
        value: {
            nombre: 'Ver compras',
            icono: 'pi pi-cart-arrow-down',
            ruta: '/compras',
            rol: ['SUPER_USUARIO', 'COMPRAS_VER']
        }
    },
    {
        label: 'Nueva compra',
        grupo: 'Compras',
        value: {
            nombre: 'Nueva compra',
            icono: 'pi pi-plus-circle',
            ruta: '/compras/nueva-compra',
            rol: ['SUPER_USUARIO', 'COMPRAS_CREAR']
        }
    },
    {
        label: 'Compras SUNAT',
        grupo: 'Compras',
        value: {
            nombre: 'Compras SUNAT',
            icono: 'pi pi-cloud-download',
            ruta: '/compras/sunat',
            rol: ['SUPER_USUARIO', 'COMPRAS_VER']
        }
    },
    {
        label: 'Ver ordenes de compra',
        grupo: 'Compras',
        value: {
            nombre: 'Ver ordenes de compra',
            icono: 'pi pi-folder-open',
            ruta: '/compras/ver-ordenes',
            rol: ['SUPER_USUARIO', 'ORDEN_COMPRA_VER']
        }
    },
    {
        label: 'Nueva orden de compra',
        grupo: 'Compras',
        value: {
            nombre: 'Nueva orden de compra',
            icono: 'pi pi-file-plus',
            ruta: '/compras/nueva-orden',
            rol: ['SUPER_USUARIO', 'ORDEN_COMPRA_CREAR']
        }
    },
    // --- Restaurante ---
    {
        label: 'Restaurante Comandero',
        grupo: 'Restaurante',
        value: {
            nombre: 'Restaurante Comandero',
            icono: 'pi pi-clipboard',
            ruta: '/restaurante/comandero',
            rol: ['SUPER_USUARIO', 'RESTAURANTE_COMANDAS_VER']
        }
    },
    {
        label: 'Carta QR',
        grupo: 'Restaurante',
        value: {
            nombre: 'Carta QR',
            icono: 'pi pi-qrcode',
            ruta: '/restaurante/carta-qr',
            rol: ['SUPER_USUARIO', 'RESTAURANTE_MESAS_VER']
        }
    },
    {
        label: 'Cocina',
        grupo: 'Restaurante',
        value: {
            nombre: 'Cocina',
            icono: 'pi pi-stopwatch',
            ruta: '/restaurante/cocina',
            rol: ['SUPER_USUARIO', 'RESTAURANTE_COCINA_VER']
        }
    },
    {
        label: 'Por servir',
        grupo: 'Restaurante',
        value: {
            nombre: 'Por servir',
            icono: 'pi pi-bell',
            ruta: '/restaurante/por-servir',
            rol: ['SUPER_USUARIO', 'RESTAURANTE_COMANDAS_VER']
        }
    },
    {
        label: 'Pedidos restaurante',
        grupo: 'Restaurante',
        value: {
            nombre: 'Pedidos restaurante',
            icono: 'pi pi-list',
            ruta: '/restaurante/pedidos',
            rol: ['SUPER_USUARIO', 'RESTAURANTE_PEDIDOS_VER']
        }
    },
    {
        label: 'Reparto',
        grupo: 'Restaurante',
        value: {
            nombre: 'Reparto',
            icono: 'pi pi-car',
            ruta: '/restaurante/reparto',
            rol: ['SUPER_USUARIO', 'REPARTO_VER']
        }
    },
    // --- Clínica ---
    {
        label: 'Agenda clínica',
        grupo: 'Clínica',
        value: {
            nombre: 'Agenda clínica',
            icono: 'pi pi-calendar',
            ruta: '/clinica/agenda',
            rol: ['SUPER_USUARIO', 'CLINICA_CITAS_VER']
        }
    }
];
